export class CustomStatsConfig {
  ChartName: string;
  Excellent: string;
  ExcelToGood: string;
  GoodToFair: string
  FairToPoor: string;
  Poor: string;

  constructor() {
    this.ChartName = "";
    this.Excellent = "";
    this.ExcelToGood = "";
    this.GoodToFair = "";
    this.FairToPoor = "";
    this.Poor = "";
  }
}
